import React from 'react';

/**
 * <Card title="Recent activity" action={<button>Refresh</button>}>...</Card>
 */
const Card = ({ title, subtitle, action, children, className = '', padding = true, footer, hover = false }) => (
    <div className={`card ${hover ? 'card-hover' : ''} ${className}`}>
        {(title || action) && (
            <div className="px-5 py-3.5 border-b border-neutral-100 flex items-center justify-between gap-3">
                <div>
                    {title && <h3 className="text-sm font-semibold text-neutral-900 tracking-tight">{title}</h3>}
                    {subtitle && <p className="text-xs text-neutral-500 mt-0.5">{subtitle}</p>}
                </div>
                {action && <div className="flex-shrink-0">{action}</div>}
            </div>
        )}
        <div className={padding ? 'p-5' : ''}>
            {children}
        </div>
        {footer && (
            <div className="px-5 py-3 border-t border-neutral-100 bg-neutral-50/70 rounded-b-xl">
                {footer}
            </div>
        )}
    </div>
);

export default Card;
